// src/hooks/library/useGetAuthorsQuery.ts
import { useQuery } from "react-query";
import { getAuthors } from "../../services/library/author";
import { key_authors } from "../../utils/constants";
import { PagedRequestType } from "../../types/PagedResults";

export const useGetAuthorsQuery = (data: PagedRequestType, options: any = null) =>
    useQuery(
        [key_authors, JSON.stringify(data)],
        () => getAuthors(data),
        options ? { ...options } : {}
    );
